import ConnectionLabelAndOwners from 'scoreboard/admin/connections/connection-label-and-owners'
import RestConnectionWizardView from 'scoreboard/admin/connections/rest/rest-connection-wizard-view'

const RestConnectionLabelAndOwners = ConnectionLabelAndOwners.extend({

	render: function() {
		RestConnectionWizardView.prototype.render.call(this)
		ConnectionLabelAndOwners.prototype.render.call(this)
	},

	submit: function() {
		RestConnectionWizardView.prototype.clearUnusedProperties.call(this)
		ConnectionLabelAndOwners.prototype.submit.call(this)
	}
})

export default RestConnectionLabelAndOwners
RestConnectionLabelAndOwners.__filename__ = 'admin/connections/rest/rest-connection-label-and-owners.js'
